import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getAuthoringLegislationGroup = api(async function getAuthoringLegislationGroup({ id }) {
    return query(
        gql`
            query GetAuthoringLegislationGroup($id: String!) {
                getAuthoringLegislationGroup(id: $id) {
                    id
                    legacyId
                    name
                    parentId
                    lastModified
                }
            }
        `,
        { id },
        { returns: "getAuthoringLegislationGroup" }
    )
})
